var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-modal",
      on: {
        click: function($event) {
          return _vm.closeModal()
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "product-modal-container no-scrollbar",
          class: _vm.expanded ? "expanded" : "",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("img", {
            staticClass: "x",
            attrs: {
              src:
                "https://cdn.shopify.com/s/files/1/1363/8433/files/x_f565b23e-dc3f-4bd6-8843-442daa0e1434.svg?v=1719947652",
              alt: "x"
            },
            on: {
              click: function($event) {
                return _vm.closeModal()
              }
            }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "main-title mobile" }, [
            _vm._v(_vm._s(_vm.product.title))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "image-container" },
            [
              _vm.isMobile()
                ? _c(
                    "VueSlickCarousel",
                    {
                      attrs: {
                        arrows: false,
                        dots: true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    },
                    _vm._l(_vm.product.images, function(image) {
                      return _c("img", {
                        key: image.id,
                        staticClass: "main-image",
                        attrs: { src: image.src }
                      })
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("img", {
                staticClass: "main-image desktop",
                attrs: { src: _vm.selectedImage }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "extra-images-container" },
                [
                  _c(
                    "Flicking",
                    {
                      ref: "flicking",
                      attrs: {
                        options: {
                          align: "prev",
                          circular: true,
                          preventDefaultOnDrag: true,
                          preventClickOnDrag: true,
                          renderOnlyVisible: true,
                          horizontal: false
                        }
                      }
                    },
                    _vm._l(_vm.product.images, function(image) {
                      return _c("img", {
                        key: image.id,
                        staticClass: "extra-image lazyload",
                        class: image.src == _vm.selectedImage ? "selected" : "",
                        attrs: { src: image.src },
                        on: {
                          click: function($event) {
                            return _vm.selectImage(image.src)
                          }
                        }
                      })
                    }),
                    0
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "information-container" }, [
            _c("p", { staticClass: "main-title desktop" }, [
              _vm._v(_vm._s(_vm.product.title))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "description-label" }, [
              _vm._v("Description")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "main-description" }, [
              _vm._v(_vm._s(_vm._f("getProductDesc")(_vm.product)))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ethos-container" },
              _vm._l(_vm.ethosTags, function(etho) {
                return _c(
                  "span",
                  { key: etho, class: _vm.badgeExtraClass(etho) },
                  [_vm._v(_vm._s(etho))]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("p", { staticClass: "grey-legend" }, [
              _vm._v(
                "This is just one amazing gift in the assortment of items your recipient will be able to choose from! Reminder: they'll never know the value you picked, and no receipts will be in the packaging."
              )
            ]),
            _vm._v(" "),
            _vm.sendCopy
              ? _c(
                  "button",
                  {
                    staticClass: "happybox-button green border",
                    on: {
                      click: function() {
                        _vm.$emit("changepage")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.sendCopy))]
                )
              : _vm._e()
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }